import PropTypes from 'prop-types';
import { Box, Center } from '@chakra-ui/react';

export default function SecondaryButton({
  text,
  icon,
  leftIcon,
  disabled,
  fontSize = '14px',
  ...props
}) {
  return (
    <Box
      className={`text-center ${
        disabled
          ? 'bg-disabled-light dark:bg-disabled-dark text-sub-light-2 dark:text-sub-dark-2'
          : 'text-onSecondary-light dark:text-onSecondary-dark bg-secondary-light dark:bg-secondary-dark'
      }`}
      borderRadius={'52px'}
      lineHeight={'17px'}
      paddingX={'12px'}
      paddingY={'8px'}
      fontWeight={500}
      fontSize={fontSize}
      alignContent={'center'}
      {...props}
    >
      <Center>
        {leftIcon && <>{leftIcon}</>}
        <p>{text}</p>
        {icon && <>{icon}</>}
      </Center>
    </Box>
  );
}

SecondaryButton.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.node, // Optional by default
  leftIcon: PropTypes.node, // Optional by default
  disabled: PropTypes.bool // Optional by default
};
